import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { DirectDebitMandateQueryDocument } from './directDebitMandateQuery.gql';

export const useDirectDebitMandateQuery = (directDebitMandateId: string) => {
  const { companyProfileId } = useCompanyContext();
  const { data, error, loading, networkStatus, refetch } = useQuery(
    DirectDebitMandateQueryDocument,
    {
      skip: !directDebitMandateId || !companyProfileId,
      variables: {
        companyProfileId: companyProfileId as string,
        directDebitMandateId,
      },
    },
  );

  const bankAccounts = data?.viewer.company.bankAccounts || [];
  const bankAccount = bankAccounts.find(
    (account) =>
      account.bankAccountId === data?.directDebitMandate.bankAccountId,
  );

  return {
    bankAccount,
    directDebitMandate: data?.directDebitMandate,
    error,
    loading,
    networkStatus,
    refetch,
  };
};
